<template>
  <WsMain>
    <template v-if="loading.fetch">
      <v-skeleton-loader
        v-for="n in 4"
        :key="`skeleton-${n}`"
        type="list-item-three-line"
        :tile="true"
        class="mt-5"
      ></v-skeleton-loader>
    </template>
    <template v-else>
      <WsMultiList
        v-if="state&&state.length"
        :value="state"
        v-bind="fields"
        :iconControlKey="fields.iconControlKey"
      ></WsMultiList>
      <template v-else>
        <WsTitle>沒有符合此快報的工廠</WsTitle>
      </template>
    </template>
  </WsMain>
</template>
<script>
export default {
  data() {
    return {
      state: [],
      loading: {
        fetch: false,
      },
      fields: {
        textKey: "name",
        icon: "mdi-domain",
        subIcon: "mdi-factory",
        iconControlKey: "child_factories",
        layerFields: [
          {
            modelKey: "child_factories",
            textKey: "name",
            icon: "mdi-domain",
            subIcon: "mdi-factory",
            iconControlKey: "child_factories",
            innerFields: [
              {
                modelKey: "factories",
                textKey: "name",
                icon: "mdi-factory",
              },
            ],
          },
          {
            modelKey: "factories",
            textKey: "name",
            icon: "mdi-factory",
          },
        ],
      },
    };
  },
  computed: {
    _query() {
      return this.$route.query;
    },
  },
  mounted() {
    this.$_fetchFilterFactoriesData();
  },
  methods: {
    async $_fetchFilterFactoriesData() {
      try {
        this.loading.fetch = true;
        const _params = {
          factories: this._query.factories,
          get_all: 1,
        };
        const res = await this.$axios.get(`/factory_check`, {
          params: _params,
        });
        this.state = res.data.data;
        this.loading.fetch = false;
      } catch (err) {
        this.loading.fetch = false;
        console.log(err);
      }
    },
  },
};
</script>